export const formatHtml = (html) => ({ __html: html });
